import React from 'react';
import { cn } from '@express-labs/raven-tools';
import s from '../Icon.scss';
import { IconV1Props } from '../Icon';

const MyAccountLoginLogo: React.FC<IconV1Props> = ({ icon }) => (
  <svg
    className={cn(s.svg, 'svg-icon--myaccountloginlogo')}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    data-icon={icon}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-13.000000, -18.000000)"
        stroke="#000000"
        strokeWidth="1.5"
      >
        <g transform="translate(14.000000, 19.000000)">
          <circle id="Oval" cx="11" cy="11" r="11" />
        </g>
      </g>
    </g>
  </svg>
);

export default MyAccountLoginLogo;
